import { Entity } from '@/store/shared/entity';
import DeclareGroup from '../declaregroup/entity';
import customsBox from './customsbox';

export default class Invoice extends Entity<number>{
    shippingNumber:string;//运单号
    senderName:string;//发货人
    senderNameEn:string;//发货人En
    owner:string;//单证
    businessGroup:string;//业务组
    shipmentDate:Date;//出运日
    customerName:string;//客户
    deal:string;//成交方式
    Payment:string;//付款方式
    shippingType:string;//运输方式
    receiverName:string;//收货人
    receiverAddress:string;//收货人地址
    startPort:string;//起运港
    endPort:string;//目的港
    countryOfArrival:string;//抵运国
    tradingCountry:string;//贸易国
    receiverAmount:string;//收汇金额
    shippingMark:string;//箱唛
    totalVolume:string;//总体积
    boxUnit:string;//箱数单位
    salesType:string;//销售类型

    //装箱
    customsBoxList:Array<customsBox> = new Array<customsBox>();

    //清单
    productList: Array<DeclareGroup>;
    constructor() {
        super();
        this.productList = new Array<DeclareGroup>();
    }
}